<template>
    <div>
        <b-row class="toolbar-ptc">
            <b-col>
                <router-link :to="{ name: 'store_menu_list', params: { search:$route.params.search } }" class="btn btn-ptc1" tag="button">返回</router-link>
            </b-col>
            <b-col class="text-center title">門市服務 / 餐點DM上傳 / {{action==2?'新增':'修改'}}</b-col>
            <b-col>
                <div class="text-right">
                    <button type="button" class="btn btn-save" @click="save(1)">儲存</button>
                </div>
            </b-col>
        </b-row>
        <div id="func-content">
            <b-card class="bg-default-card">
                <div class="row">
                    <div class="col-lg-12">
                        <form class="form-horizontal form-validation">

                          <div class="col-lg-12">
                              <div class="form-group">
                                <label class="control-label">品牌：</label>
                                <div>
                                  <select
                                    name="queryBrandsCode"
                                    class="form-control"
                                    v-model="brandCode"
                                  >
                                  <option
                                    v-for="x in selectListBrands"
                                    v-bind:value="x.Code"
                                    :key="x.Code"
                                  >{{x.Text}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="form-group">
                                    <label class="control-label">餐點類別</label>
                                    <input type="text" class="form-control" v-model="title" maxlength="8" placeholder="請輸入餐點類別">
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="form-group">
                                    <label class="control-label">圖片上傳</label>
                                    <div class="form-group">
                                        <input type="file" class="upload_input" id="pic" @change="handleFileChange" ref="inputer">
                                        <label class="upload_block" for="pic">
                                            <span class="upload_icon">➕</span>
                                            <img class="upload_img" v-if="dataUrl != undefined" :src="file==undefined? dataUrl : dataUrl" />
                                        </label>
                                    </div>
                                    <span class="control-label text-red" style="color: #ff0000">**寬度最小750 高度建議超過1334**</span>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label class="control-label">開始日期</label>
                                            <input type="date" class="form-control" v-model="sdate" :disabled="status==1&&old_sdate<=today"  max="9999-12-31" @input="changeDate($event, 1)" v-on:keydown="keydownDate($event, 1)">
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label class="control-label">結束日期</label>
                                            <input type="date" class="form-control" v-model="edate"  max="9999-12-31" @input="changeDate($event, 2)" v-on:keydown="keydownDate($event, 2)">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </b-card>

            <!-- Double Check Modal -->
            <b-modal ref="mdCheck" hide-footer title="餐點DM變更">
            <b-container fluid>
                <form>
                  <div class="row mb-3">
                    <label class="control-label" v-if="action==2">確定新增餐點DM ?</label>
                    <label class="control-label" v-else-if="new_status==2">確定<span style="color: #ff0000">下架</span>此則餐點DM ?</label>
                    <label class="control-label" v-else>確定儲存此則餐點DM ?</label>
                  </div>
                  <div class="float-right">
                    <b-btn variant="primary" @click="confirm">確定</b-btn>
                    <b-btn variant="secondary" @click="cancel">取消</b-btn>
                  </div>
                </form>
            </b-container>
            </b-modal>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import {API_URL, fileUploadMaxSize} from '../../../store/root.js'
import miniToastr from 'mini-toastr'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
miniToastr.init()
export default {
  data () {
    return {
      id: 0,
      sdateInvalid: false,
      edateInvalid: false,
      title: '',
      dataUrl: '',
      sdate: '',
      new_status: 1,
      edate: '',
      API_URL: API_URL,
      today: '',
      brandCode: '',
      selectListBrands: [], // 品牌下拉選單
    }
  },
  props: {
    value: {
      default: undefined
    }
  },
  methods: {
    changeDate (e, type) {
      // 日期變更事件
      if (type === 1) {
        this.sdateInvalid = e.target.validity.badInput
      } else {
        this.edateInvalid = e.target.validity.badInput
      }
    },
    keydownDate (e, type) {
      // 日期輸入事件
      if (type === 1) {
        this.sdateInvalid = e.target.validity.badInput
      } else {
        this.edateInvalid = e.target.validity.badInput
      }
    },
    getTomorrow () {
      var date = new Date()
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var day = date.getDate() + 1

      if (mon < 10) {
        mon = '0' + mon
      }

      var fullDate = year + '-' + mon + '-' + day

      return fullDate
    },
    handleFileChange (e) {
      let inputDOM = this.$refs.inputer
      this.file = inputDOM.files[0]
      this.$emit('input', this.file)
      this.fileName = this.file.name
      if (!this.imgPreview(this.file)) {
        this.$refs.inputer.value = ''
        this.dataUrl = undefined
      }
    },
    imgPreview (file) {
      var rtn = false
      let self = this
      if (!file || !window.FileReader) return

      if (/^image/.test(file.type)) {
        if (file.size > fileUploadMaxSize) {
          miniToastr.error('圖檔大小不可超過 5MB')
        } else {
          let reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onloadend = function () {
            self.dataUrl = this.result
          }
          rtn = true
        }
      } else {
        miniToastr.error('請選擇正確圖檔')
      }
      return rtn
    },
    ddlCampChange () {
      this.ddl_camp = 0
    },
    save (type) {
      if (this.title.trim() === '') {
        miniToastr.error('請輸入標題文字')
        return
      }
      if (this.dataUrl === undefined || this.dataUrl === '') {
        miniToastr.error('請選擇上傳圖片')
        return
      }
      if (this.sdateInvalid || this.edateInvalid) {
        miniToastr.error('日期格式輸入錯誤，請重新輸入')
        return
      }
      if (this.sdate === '' || this.edate === '') {
        miniToastr.error('請輸入廣告日期區間')
        return
      }
      if (this.action === 2) { // 狀態為已下架或草稿
        if (this.sdate < this.today) {
          miniToastr.error('開始日期不得小於系統時間')
          return
        }
        if (this.sdate > this.edate) {
          miniToastr.error('結束日期不得小於開始日期')
          return
        }
        this.new_status = type
      } else {
        if (this.status === 1 && this.old_sdate > this.today && this.sdate < this.today) {
          miniToastr.error('開始日期不得小於系統時間')
          return
        }
        if (this.sdate > this.edate && this.edate >= this.today) {
          miniToastr.error('結束日期不得小於開始日期')
          return
        }
        if (this.edate < this.today) {
          this.new_status = 2
        } else {
          this.new_status = 1
        }
      }
      this.$refs.mdCheck.show()
    },
    confirm () {
      this.$refs.mdCheck.hide()
      let formData = new FormData()
      formData.append('image', this.file)
      formData.append('imgUrl', this.dataUrl)
      formData.append('title', this.title)
      formData.append('brandCode', this.brandCode)
      if (this.new_status === 2) {
        formData.append('sdate', this.old_sdate)
        formData.append('edate', this.old_edate)
      } else {
        formData.append('sdate', this.sdate)
        formData.append('edate', this.edate)
      }
      if (this.action === 2) {
        this.formData = formData
        this.createleaflet()
      } else {
        formData.append('id', this.id)
        formData.append('status', this.new_status)
        this.formData = formData
        this.updateleaflet()
      }
    },
    createleaflet () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/create/leaflet/v1',
        this.formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('餐點DM上傳成功')
            this.$router.push({ name: 'store_menu_list' })
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else if (response.data.result === '1113') {
            miniToastr.error(response.data.message)
          } else {
            miniToastr.error(response.data.message, '上傳菜單失敗')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          this.$parent.Loading = false
        })
    },
    updateleaflet () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/update/leaflet/v1',
        this.formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('餐點DM已變更')
            this.$router.push({ name: 'store_menu_list', params: { search: this.$route.params.search } })
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else if (response.data.result === '1113') {
            miniToastr.error(response.data.message)
          } else {
            miniToastr.error(response.data.message, '修改菜單失敗')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log(error)
          this.$parent.Loading = false
        })
    },
    cancel () {
      this.$refs.mdCheck.hide()
    },
    getYYYYMMDD (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      return year + '/' + month + '/' + day
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v2", {
          all: false,
          order: false,
          menupage: true
        })
        .then(response => {
          this.selectListBrands = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListBrands = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F09') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
      return
    }
    var params = this.$route.params
    if (params.item === undefined) {
      this.$router.push({ name: 'store_menu_list', params: { search: this.$route.params.search } })
      return
    }

    var item = params.item
    this.action = params.action
    this.search = params.search

    this.id = item.ID
    this.title = item.CategoryText
    this.dataUrl = item.ImageURL
    this.status = item.Status
    this.brandCode = item.BrandCode
    var date = new Date()
    var year = date.getFullYear()
    var mon = date.getMonth() + 1
    var day = date.getDate()

    if (mon < 10) {
      mon = '0' + mon
    }
    if (day < 10) {
      day = '0' + day
    }
    if (this.action === 1) {
      this.sdate = this.old_sdate = item.EnabledAt.substring(0, 10)
      this.edate = this.old_edate = item.DisabledAt.substring(0, 10)
    } else {
      this.sdate = this.old_sdate = year + '-' + mon + '-' + day
      this.edate = this.old_edate = '9999-12-31'
    }
    this.today = year + '-' + mon + '-' + day

    this.querySelectListBrands();
  }
}
</script>
<style scoped>
    .upload_block {
        position: relative;
        width: 260px;
        height: 180px;
        text-align: center;
        vertical-align: middle;
        cursor: pointer;
        background: #f1f1f1;
        border: 3px dashed #d6d4d4;
    }
    .upload_input {
        display: none;
    }
    .upload_img {
        width: 100%;
        height: 100%;
        position: relative;
        z-index: 2;
    }
    .upload_icon {
        font-weight: bold;
        font-size: 200%;
        position: absolute;
        z-index:1;
        left: 0;
        width: 100%;
        top: 35%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/store/menu/Edit.vue